export default __webpack_public_path__ + "static/media/volcano.3f97caf7.mp3";